import * as Yup from 'yup';
import React from 'react';

export const MAIL_REG_EXP = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const Email_REG_EXP = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
const telePhoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const cellPhoneRegExp = /^0?9\d{8}$/;

const ipv4RegExp =
  /(^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$)/;

export const string_required = () => Yup.string().required("此為必填欄位");

///Email
export const email = () => Yup.string().email("無效的 Email");
export const email_required = () => email().required("此為必填欄位");

///密碼
export const password = () =>
  Yup.string()
    .required("此為必填欄位")
    .max(24, "密碼不可超過 24 個字符")
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{12,})/, "必須包含 12 個字符，1 個大寫字母，1 個小寫字母，1 個數字");

export const repassword = (pasword_id) =>
  Yup.string()
    .oneOf([Yup.ref(pasword_id), null], "密碼不一致")
    .required("此為必填欄位");

///使用者名稱
export const user_name = () =>
  Yup.string().min(2, "至少2個字").required("此為必填欄位");

// 電話驗證
export const tel_rule = Yup.string()
  .matches(telePhoneRegExp, "非電話格式");

//使用者電話(非必填或需電話驗證)
export const user_tel = Yup.string().test(
  "tel-validation",
  "非電話格式",
  function (value) {
    if (!value || value.trim() === "") return true;
    return tel_rule.isValidSync(value);
  }
);

///公司名稱
export const company_name = () =>
  Yup.string().min(6, "至少6個字").required("此為必填欄位");
export const company_name_not_required = () => Yup.string().min(6, "至少6個字");

// 公司所屬城市
export const company_country = () =>
  Yup.string().min(2, "至少2個字").required("此為必填欄位");

//公司電話
export const company_tel = () =>
  Yup.string()
    .required("此為必填欄位")
    .matches(telePhoneRegExp, "非電話格式");

export const telephone = () =>
  Yup.string().matches(telePhoneRegExp, '不符合市話格式', {
    excludeEmptyString: true,
  });

//是不是同意接受 隱私聲明和使用條款
export const is_read_agree = () => Yup.boolean().required('').oneOf([true], "此為必填欄位");


///AuthCode
export const AuthCode = () => Yup.string().min(20, "至少20個字").required("此為必填欄位");
//日期選擇器
export const date_picker = () => Yup.string().required("此為必填欄位");

export const at_least_one_permission = () =>
  Yup.object().shape({
    cloud_native: Yup.boolean(),
    crowdstrike: Yup.boolean(),
  }).test(
    "at-least-one",
    "授權必須至少選擇一個",
    (value) => value.cloud_native || value.crowdstrike
  );


///project name
export const project_name = () =>
  Yup.string().min(4, "至少4個字").required("此為必填欄位");

///文件編碼
export const document_no = () => Yup.string().min(4, "至少4個字").required("此為必填欄位");

//文件報告標題
export const document_name = () =>
  Yup.string().min(4, "至少4個字").required("此為必填欄位");

// CMDB Class Field
export const number_text = (minNum, maxNum) =>
  Yup.number().min(minNum, '需大於等於${min}').max(maxNum, '需小於等於${max}').typeError('必須是數字');

export const number_text_required = (minNum, maxNum) =>
  number_text(minNum, maxNum).required("此為必填欄位");

///組合Schema
export const GetSchema = (schemaObj) => {
    return Yup.object(schemaObj);
  };
